/**
 * Valor digitado em reais como número em texto para o schema: "250.000,50" e "1.200" (ponto de milhar),
 * "250000.5" (ponto decimal) ou "R$ 1.200". Vazio vira null.
 */
export function moneyInput(v: string): string | null {
  const t = v.replace(/R\$|\s/g, '');
  if (t === '') return null;
  if (t.includes(',')) return t.replace(/\./g, '').replace(',', '.');
  return /^\d{1,3}(\.\d{3})+$/.test(t) ? t.replace(/\./g, '') : t;
}

/** Valor em reais para o campo do formulário ("250.000,00"); null vira vazio. */
export const moneyText = (v: number | null | undefined) =>
  v === null || v === undefined
    ? ''
    : v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
